import * as does from 'utilities/does';
import * as is from 'utilities/is';
import { insideIFrame } from 'utilities/dom';
import { pageInformation } from 'utilities/context';
import { stringToRegex } from 'utilities/transform';
import { DEFAULT_WHITELIST } from 'configuration/defaults';

const domainIsApproved = ({ whitelist = [], currentDomain = '' }) => {
    const emptyWhitelist = whitelist.length === 0;

    if (emptyWhitelist) return true;

    if (!emptyWhitelist && currentDomain === '') return false;
    
    const invalidRegex = !whitelist.every(item => is.validRegex(item));
    if (invalidRegex) return false;

    whitelist = whitelist.concat(DEFAULT_WHITELIST);
    whitelist = whitelist.map(item => stringToRegex(item));
    return does.arrayHaveRegexMatch(currentDomain, whitelist);
}

const contentIsExpired = ({ expirationDate } ) => {
    const currentTime = new Date().getTime();

    return !!expirationDate ? new Date(expirationDate).getTime() < currentTime : false;
}

const assessAuth = ({ contentIsExpired, domainIsApproved }) => {
    let isAuthorized = false;

    if (contentIsExpired === false && domainIsApproved === true) {
        isAuthorized = true;
    }

    return {isAuthorized};
}

const pageReferrer = () => document.referrer;
const pageHref = () => pageInformation.href;
const pageSource = insideIFrame() ? pageReferrer() : pageHref();

const getAuthorization = ({ expirationDate, whitelist, currentDomain }) => {
    return assessAuth({
        domainIsApproved: domainIsApproved({whitelist, currentDomain}),
        contentIsExpired: contentIsExpired({expirationDate})
    });
}

export { domainIsApproved, contentIsExpired, assessAuth, getAuthorization, pageSource, pageReferrer, pageHref };